import { render, staticRenderFns } from "./EmptyProject.vue?vue&type=template&id=77782b63&"
import script from "./EmptyProject.vue?vue&type=script&lang=js&"
export * from "./EmptyProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports